import { useCallback, useEffect, useRef } from 'react';

import { useFrontendLogger } from '@/queries/logger/useFrontendLogger';

const useLogger = () => {
  const logMessages = useRef<string[]>([]);
  const { logDump } = useFrontendLogger();

  const sendLogs = useCallback(async () => {
    if (logMessages.current.length === 0) return;

    // Maak een kopie van de huidige logberichten
    const logsToSend = [...logMessages.current];

    try {
      // Verzend de kopie van de logs
      await logDump(logsToSend.join('\n'));

      // Verwijder alleen de verzonden logs en bewaar eventueel toegevoegde nieuwe logs
      logMessages.current = logMessages.current.slice(logsToSend.length);
    } catch (error) {
      console.error('Error sending logs:', error);
    }
  }, [logDump]);

  const log = (message: string, immediate = false) => {
    logMessages.current.push(message);

    if (immediate) {
      sendLogs();
    }
  };

  useEffect(() => {
    // Start een interval dat elke 30 seconden de logs verstuurt
    const intervalId = setInterval(() => {
      sendLogs();
    }, 30000); // 30 seconden

    return () => {
      clearInterval(intervalId);
      sendLogs();
    };
  }, [sendLogs]);

  return log;
};

export default useLogger;
